export const SIGN_IN_UNAVAILABLE = 'Sign-in is temporarily unavailable. Please contact your administrator.';

export const loginAvailabilityMessage = (status) => {
  const blocked = ['Running', 'Needs recovery'];
  return status?.mode === 'real' &&
    (status.ready === false || blocked.includes(status.status) || blocked.includes(status.work_archive_status))
    ? SIGN_IN_UNAVAILABLE : '';
};

export const loginErrorMessage = (error) => {
  const status = error?.response?.status;
  if (!status) return 'Unable to reach the sign-in service. Please try again shortly.';
  if (status === 401) return 'Invalid username or password.';
  if (status === 429) return 'Too many sign-in attempts. Please try again later.';
  if (status === 403) return 'Sign-in is unavailable for this account. Please contact your administrator.';
  if (status === 400 || status === 422) return 'Check your username and password, then try again.';
  return SIGN_IN_UNAVAILABLE;
};